const WITHDRAW_BANK_INFO_STORAGE_KEY = "withdraw_bank_info";

const getWithdrawBankInfoStorageKey = (
  userId?: string | number
): string | null => {
  if (userId === undefined || userId === null || userId === "") {
    return null;
  }

  return `${WITHDRAW_BANK_INFO_STORAGE_KEY}_${userId}`;
};

export const getWithdrawBankInfo = <T = any>(
  userId?: string | number
): T | null => {
  const storageKey = getWithdrawBankInfoStorageKey(userId);
  if (!storageKey) {
    return null;
  }

  const savedBankInfo = localStorage.getItem(storageKey);
  if (!savedBankInfo) {
    return null;
  }

  try {
    return JSON.parse(savedBankInfo) as T;
  } catch (error) {
    console.error("Failed to parse saved bank info:", error);
    return null;
  }
};

export const saveWithdrawBankInfo = (
  bankInfo: any,
  userId?: string | number
) => {
  const storageKey = getWithdrawBankInfoStorageKey(userId);
  if (!storageKey) {
    return;
  }

  localStorage.setItem(storageKey, JSON.stringify(bankInfo));
};
